module.exports = __webpack_public_path__ + "static/media/team5.ce8e378c.png";